import React from 'react'

const Eventssubscriptiondata = () => {
    return (
        <div>

        </div>
    )
}

export default Eventssubscriptiondata
